import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";

function Instructions() {
  const data = useSelector((state) => state.auth.data);
  const [timeLeft, setTimeLeft] = useState({
    days: 0,
    hours: 0,
    minutes: 0,
    seconds: 0,
  });

  function calculateTimeLeft() {
    const now = new Date();
    const istTime = new Date(
      now.toLocaleString("en-US", { timeZone: "Asia/Kolkata" })
    );
    if (data.exam) {
      const examTime = new Date(data.exam.exam_date);
      const diffInSeconds = Math.floor((examTime - istTime) / 1000);

      if (diffInSeconds <= 0) {
        return { hours: 0, minutes: 0, seconds: 0 };
      }

      return {
        days: Math.floor(diffInSeconds / (3600 * 24)),
        hours: Math.floor((diffInSeconds % (3600 * 24)) / 3600),
        minutes: Math.floor((diffInSeconds % 3600) / 60),
        seconds: diffInSeconds % 60,
      };
    } else {
      return {
        days: 0,
        hours: 0,
        minutes: 0,
        seconds: 0,
      };
    }
  }

  useEffect(() => {
    // 1-second delay before the first update
    const timeout = setTimeout(() => {
      setTimeLeft(calculateTimeLeft());

      // Now start the interval to update every second
      const timer = setInterval(() => {
        setTimeLeft(calculateTimeLeft());
      }, 1000);

      return () => clearInterval(timer); // Cleanup on unmount
    }, 1000);

    return () => clearTimeout(timeout); // Cleanup on unmount
  }, [data]);

  // const user = useSelector((state) => state.auth.user);
  const now = new Date();
  const istTime = new Date(
    now.toLocaleString("en-US", { timeZone: "Asia/Kolkata" })
  );
  if (data.exam) {
    const examTime = new Date(data.exam.exam_date);
    const diffInSeconds = Math.floor((examTime - istTime) / 1000);

    if (diffInSeconds < 1) {
      window.location.href = "/home/exam";
    }
  }

  console.log(data.exam.instructions )
  
  return (
    <div className="instruction-container">
      <div className="instructions">
        <div className="instructions-lines">
          {1 > 0 ? (
            <div
              className=" time-box"
              style={{
                textAlign: "center",
                fontSize: "50px",
                color: "red",
                fontWeight: "bold",
              }}
            >
              {timeLeft.hours.toString().padStart(2, "0")}:
              {timeLeft.minutes.toString().padStart(2, "0")}:
              {timeLeft.seconds.toString().padStart(2, "0")}
            </div>
          ) : (
            <></>
          )}
          <div className="instructions-content" dangerouslySetInnerHTML={{ __html: data.exam.instructions }} />
        </div>
      </div>
    </div>
  );
}

export default Instructions;
